import React, { useMemo, useState, useEffect } from "react";
import { useTranslation } from 'react-i18next';
import {
  View,
  Text,
  TextInput,
  TouchableOpacity,
  Modal,
  StyleSheet,
  Platform,
  Image
} from "react-native";
// import DateTimePicker from "@react-native-community/datetimepicker";
import IdCard from "../../../../../../../../assets/images/id-card.png";
import { useSessionStore } from "../../../../../../../state/src/useSessionStore";
import type { SessionState } from "../../../../../../../state/src/useSessionStore";
import identificationsData from "../../../../../constants/identifications.json";
// import { Ionicons } from "@expo/vector-icons";

type Props = {
  onValidationChange?: (isValid: boolean) => void;
  onReferenceNumberChange?: (referenceNumber: string) => void;
};

const ReceiverReferenceNumberStep: React.FC = ({ onValidationChange, onReferenceNumberChange }: Props) => {
  const { t, i18n } = useTranslation();
  const [idNumber, setIdNumber] = useState("");
  const isReceiver = useSessionStore((s: SessionState) => (s as any).isReceiver);
    console.log('isReceiver==>', isReceiver)
  const selectedIdTypeLabel = useSessionStore((s: SessionState) => (s as any).selectedIdTypeLabel);
  const setSenderPhotoIdNumber = useSessionStore((s: SessionState) => (s as any).setSenderPhotoIdNumber);

  const placeholderText = useMemo(() => {
    const baseLabel = selectedIdTypeLabel || (i18n.language === 'es' ? t('IDENTIFICATION_NUMBER') : t('IDENTIFICATION_NUMBER'));
    const suffix = i18n.language === 'es' ? 'Número' : 'Number';
    return `${baseLabel} ${suffix}`;
  }, [selectedIdTypeLabel, i18n.language, t]);

  const isValid = idNumber != "" ;
      
  useEffect(() => {
    if (onValidationChange) {
      onValidationChange(isValid);
    }
  }, [isValid, onValidationChange]);



  const handleManualInput = async (text: string) => {
    setIdNumber(text);
    try { onReferenceNumberChange?.(text); } catch {}
    // handle receiver reference number here

    // try { setSenderPhotoIdNumber?.(text); } catch {}
  };

  return (
    <View style={styles.container}>
      <Text style={styles.title}>{t("LOOK_UP_TRANSFER")}</Text>
      <Text style={styles.subtitle}>{t("LOOK_UP_SUBTITLE")}</Text>

        <TextInput
          style={styles.inputWrapper}
          placeholder={t("REFERENCE_NUMBER")}
          keyboardType="numeric"
          value={idNumber}
          onChangeText={handleManualInput}
        />
      <Text style={[styles.subtitle, styles.sampleText]}>{t("REFERENCE_SAMPLE")}</Text>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    paddingHorizontal: 24,
    backgroundColor: "#fff"
  },
  title: {
    fontFamily: 'Rubik',
    fontSize: 28,
    fontWeight: "500",
    lineHeight: 34,
    color: '#1F1F1F'
  },
  subtitle: {
    fontFamily: 'Rubik',
    fontSize: 16,
    fontWeight: "400",
    lineHeight: 24,
    color: '#666',
    marginTop: 8
  },
  inputWrapper: {
    marginTop: 49,
    height: 56,
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: "#f5f5f5",
    borderRadius: 8,
    paddingHorizontal: 16,
    paddingVertical: 8,
    fontFamily: 'Rubik',
    fontSize: 16,
    fontWeight: "400",
    lineHeight: 24,
    color: '#737373'
  },
  sampleText: {
    fontSize: 14,
    lineHeight: 20,
    marginBottom: 60
  },
  modalOverlay: {
    flex: 1,
    justifyContent: "flex-end",
    backgroundColor: "rgba(0,0,0,0.4)",
  },
  bottomSheet: {
    backgroundColor: "#fff",
    padding: 20,
    borderTopLeftRadius: 16,
    borderTopRightRadius: 16,
  },
  modalTitle: { fontSize: 18, fontWeight: "700", marginBottom: 10 },
  modalText: { fontSize: 15, color: "#555" },
  modalDOB: {
    fontSize: 18,
    fontWeight: "600",
    marginTop: 10,
    marginBottom: 20,
    textAlign: "center",
  },
  confirmBtn: {
    backgroundColor: "#000",
    padding: 14,
    borderRadius: 8,
    alignItems: "center",
  },
  confirmText: { color: "#fff", fontWeight: "600", fontSize: 16 },
  cancelBtn: { marginTop: 10, alignItems: "center" },
  cancelText: { fontSize: 15, color: "#666" },
});

export default ReceiverReferenceNumberStep;